import React from "react";
import "./App.css";
import { ThemeProvider, useTheme } from "next-themes";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import OpportunityTicker from "./components/OpportunityTicker";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ChatAssistant from "./components/ChatAssistant";
import TargetCursor from "./components/TargetCursor";

const ThemeToaster = () => {
  const { theme } = useTheme();
  return <Toaster position="top-center" theme={theme === "dark" ? "dark" : "light"} richColors />;
};

function App() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange
    >
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Header />
                  <main id="home">
                    <Hero />
                    <OpportunityTicker />
                    <About />
                    <Skills />
                    <Projects />
                    <Experience />
                    <Education />
                    <Contact />
                  </main>
                  <Footer />
                </>
              }
            />
          </Routes>
        </BrowserRouter>
        <ThemeToaster />
        <ChatAssistant />
        <TargetCursor
          spinDuration={2}
          hideDefaultCursor
          parallaxOn
          hoverDuration={0.2}
          cursorColor="#ffffff"
          cursorColorOnTarget="#B497CF"
        />
      </div>
    </ThemeProvider>
  );
}

export default App;